export default "__VITE_ASSET__CvyTi3ou__"